__turbopack_context__.v({
  "className": "poppins_54b9207b-module__n6UBEW__className",
});
